import PropTypes from 'prop-types';
import React from 'react';
import b from 'b_';
import cn from 'classnames';
import { isFuse5Enabled } from '../../fuseFeatureFlag';
import './Bg.css';
import './oldBg.css';

// TODO: draw mesh programmatically
export default function Bg({ type, className, children, ...otherProps }) {
    const blockClass = isFuse5Enabled() ? b.lock('NewBg')({ type }) : b.lock('Bg')({ type });
    return <div
        className={cn(blockClass, className)}
        {...otherProps}
    >{children}</div>;
}

Bg.propTypes = {
    type: PropTypes.oneOf(['none', 'bottom', 'center']),
    className: PropTypes.string,
    children: PropTypes.node,
};

Bg.defaultProps = {
    type: 'bottom',
};
